import { render, staticRenderFns } from "./Poste.vue?vue&type=template&id=3fd71191&scoped=true&"
import script from "./Poste.vue?vue&type=script&lang=js&"
export * from "./Poste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd71191",
  null
  
)

export default component.exports